module.exports = __webpack_public_path__ + "static/media/lv.fd6d3e79.png";